import { TokenABI } from "@abi/TokenABI";
import { useCallback } from "react";
import type { Address } from "viem";
import { useSimulateContract, useWriteContract } from "wagmi";

const useApprove = (
	tokenContractAddress: Address,
	spender: Address,
	approveAmt: bigint,
) => {
	const { data } = useSimulateContract({
		abi: TokenABI,
		address: tokenContractAddress,
		args: [spender, approveAmt],
		functionName: "approve",
	});

	const {
		isPending: isLoading,
		isSuccess,
		status,
		writeContract,
	} = useWriteContract();
	const write = useCallback(() => {
		if (data?.request) {
			return writeContract(data?.request);
		}
	}, [data]);
	return { data, isLoading, isSuccess, send: write, status };
};

export default useApprove;
